import Localize from 'react-intl-universal';

import * as yup from 'yup';

import { PASSWORD_REGEX } from '@common/Constants';

export default () => {
  return yup.object().shape({
    currentPassword: yup.string().required(Localize.get('Validation.requiredField')),
    newPassword: yup
      .string()
      .required(Localize.get('Validation.requiredField'))
      .min(8, Localize.get('MyProfile.minCharacter'))
      .matches(PASSWORD_REGEX, Localize.get('Validation.missingCondition')),
    confirmNewPassword: yup
      .string()
      .required(Localize.get('Validation.requiredField'))
      .oneOf([yup.ref('newPassword'), null], Localize.get('Validation.mustMatch'))
  });
};
